/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleReportFactData
 */
export interface GoogleSearchConsoleReportFactData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleReportFactData
     */
    date?: Date;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GoogleSearchConsoleReportFactData
     */
    dimensions?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportFactData
     */
    clicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportFactData
     */
    impressions?: string;
    /**
     * Provider row CTR. Recompute from summed clicks/impressions after aggregation.
     * @type {string}
     * @memberof GoogleSearchConsoleReportFactData
     */
    ctr?: string;
    /**
     * Provider row average position. Null when the search surface does not provide position; never sum across rows.
     * @type {string}
     * @memberof GoogleSearchConsoleReportFactData
     */
    position?: string | null;
}

/**
 * Check if a given object implements the GoogleSearchConsoleReportFactData interface.
 */
export function instanceOfGoogleSearchConsoleReportFactData(value: object): value is GoogleSearchConsoleReportFactData {
    return true;
}

export function GoogleSearchConsoleReportFactDataFromJSON(json: any): GoogleSearchConsoleReportFactData {
    return GoogleSearchConsoleReportFactDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleReportFactDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleReportFactData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'dimensions': json['dimensions'] == null ? undefined : json['dimensions'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
    };
}

export function GoogleSearchConsoleReportFactDataToJSON(json: any): GoogleSearchConsoleReportFactData {
    return GoogleSearchConsoleReportFactDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleReportFactDataToJSONTyped(value?: GoogleSearchConsoleReportFactData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'dimensions': value['dimensions'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'position': value['position'],
    };
}

